var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16.6 16.6"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.37,
  "data-name": "Group 19473"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.299.685v15.23",
  "data-name": "Line 679"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.685 7.999h15.23",
  "data-name": "Line 680"
}))));
export { SvgPlus2 as ReactComponent };
export default __webpack_public_path__ + "static/media/plus2.febf9063fa7e6c832b88ebddbef4a77a.svg";